module.exports = __webpack_public_path__ + "img/logo.c60d4c16.svg";